import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';


import { BehaviorSubject } from 'rxjs';
import { LookupService } from '../api-module/services/lookup-services/lookup.service';
import { SharedNotificationService } from '../shared-module/shared/shared-notification.service';

@Injectable({
  providedIn: 'root'
})

export class NotificationsService {

  currentMessage = new BehaviorSubject(null);

  constructor(private afMessage: AngularFireMessaging, private lookupService: LookupService, private headerNotificationService: SharedNotificationService) {
    this.afMessage.messages.subscribe(
      (_messaging: AngularFireMessaging) => {
        console.log("testMessageFromNotificationsService", _messaging);
        // _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        // _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
        var message :any = _messaging
        message.data.data =   JSON.parse(message.data.data);
        this.currentMessage.next(message);
        this.headerNotificationService.notificationData.next(message);

      }
    )
  }


  getPermission() {
    this.afMessage.requestPermission
      .subscribe(
        (res: any) => {
          this.afMessage.getToken
            .subscribe(
              (res: any) => {
                if (res) {
                  this.lookupService.addUserDevice(res)
                    .subscribe(
                      (res) => {
                        console.log("device registered successfully");
                      },
                      (err) => {
                        console.log(err);
                      }
                    );
                }
              }
            );
        }, (err) => {
          console.warn("notification is disabled in browser!", err);
        });
  }
  requestPermission() {
    this.afMessage.requestToken.subscribe(
      (token) => {
        console.log(token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }
  // receiveMessage() {
  //   // this.afMessage.messages.subscribe(
  //   //   (payload) => {
  //   //     console.log("new message received. ", payload);
  //   //     this.currentMessage.next(payload);
  //   //   })
  //   return this.afMessage.messages;
  // }


  // receiveMessage() {
  //   // this.afMessage.messages.subscribe(
  //   //   (payload) => {
  //   //     console.log("new message received. ", payload);
  //   //     this.currentMessage.next(payload);
  //   //   })
  //   return this.afMessage.messages;
  // }
}

